import {Component} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {BaseWelcomeComponent} from '@catapp/shared/feature/create-form-wizards/base-welcome.component';
import {FeatureTypeService} from '@catcore/services';
import {buildSelectItemsFor} from '@catcore/utils/form-utils';
import {GenericResourceApiService} from '@catfeatures/services/generic-resource-api.service';
import {EvidVidsService} from '@catmodules/models/evid-vids/services/evid-vids.service';
import {EvidVid} from '@catmodules/models/evid-vids/types';
import {EvidVidTypeService} from '@catmodules/models/evid/services/evid-vid-type.service';
import {Evid} from '@catmodules/models/evid/types';
import {FeatureEvidVidService} from '@catmodules/models/feature-evid-vid/services/feature-evid-vid.service';
import {SelectItem} from 'primeng/primeng';
import {isNullOrUndefined} from 'util';

/**
 * A component to fast create a new FeatureEvidVid for the currently used FeatureEvidFunction
 *
 * A new FeatureEvidVid inherits the some properties of its linked EvidTimer.
 *
 * This properties are:
 * - name
 * - valueString
 * - defaultValue
 */
@Component({
  templateUrl: './feature-evid-vid-wizard-form.component.html',
  styleUrls: ['./feature-evid-vid-wizard-form.component.scss'],
})
export class FeatureEvidVidWizardFormComponent extends BaseWelcomeComponent {

  selfLabel = 'Feature Evid Vid';
  title = `New ${this.selfLabel}`;
  labels = {
    evidVid: 'Evid Vid',
    evid: 'Evid',
    name: 'Name',
    valuesString: 'Values String',
    defaultValue: 'Default Value',
    buttons: {last: `Save the ${this.selfLabel}`},
  };

  controlRefs = {
    evidVid: 'evidVid',
    evid: 'evid',
    name: 'name',
    valuesString: 'valuesString',
    defaultValue: 'defaultValue',
  };

  evidVidSelectItems: SelectItem[];
  evidSelectItems: SelectItem[];
  featureEvidFunction: any;

  get formIsReady() {
    let isReady = !isNullOrUndefined(this.featureEvidFunction);
    isReady = isReady && !isNullOrUndefined(this.form);
    return isReady;
  }

  constructor(private evidVidService: EvidVidsService,
              private evidService: EvidVidTypeService,
              private featureService: FeatureTypeService,
              private featureEvidVidService: FeatureEvidVidService,
              private resourceService: GenericResourceApiService) {
    super();
    this.form = new FormGroup({
      evidVid: new FormControl('', [Validators.required]),
      evid: new FormControl('', [Validators.required]),
      name: new FormControl('', [Validators.required]),
      valuesString: new FormControl('', [Validators.required]),
      defaultValue: new FormControl('', [Validators.required]),
    });

  }

  getFeatureEvidFunction() {
    return this.featureEvidFunction;
  }

  saveNewEntity() {

    this.featureEvidVidService
      .create({
        evidFunction: this.getFeatureEvidFunction(),
        evidVid: this.form.value.evidVid,
        evid: this.form.value.evid,
        name: this.form.value.name,
        valuesString: this.form.value.valuesString,
        defaultValue: this.form.value.defaultValue,
      })
      .subscribe((item) => {
        this.setCurrentEntity(item);
        this.setIsCompleted(item !== null);
        this.featureService.refreshCurrent();
      })
    ;

  }

  beforeDisplayProperties(): void {
    this.resourceService
      .getFromParentResource()
      .subscribe((featureEvidFunction: any) => this.featureEvidFunction = featureEvidFunction);
    this.evidVidService
      .getAll()
      .subscribe((items: EvidVid[]) => this.updateEvidVidSelectItems(items));
    this.evidService
      .getAll()
      .subscribe((items: Evid[]) => this.updateEvidSelectItems(items));

  }

  resetFormResult() {
  }

  validatePropertiesView() {
  }

  getLabelOfContextItem(contextItem): string {
    return contextItem._links.model.label;
  }

  changeEvidVid($event) {
    if (!isNullOrUndefined($event.value)) {
      this.form.patchValue({name: $event.value.name});
      this.form.patchValue({valuesString: $event.value.values_string});
      this.form.patchValue({defaultValue: $event.value.default_value});
    }
  }

  private updateEvidVidSelectItems(items: EvidVid[]): void {
    this.evidVidSelectItems = buildSelectItemsFor(items, 'name');
  }

  private updateEvidSelectItems(items: Evid[]): void {
    this.evidSelectItems = buildSelectItemsFor(items, 'name');
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/feature-evid-vid/components/feature-evid-vid-wizard-form/feature-evid-vid-wizard-form.component.ts